import { Tag } from 'antd';
import { FunctionComponent } from 'react';
import { Gift, GiftStatus } from '../services/gift-service/types';
import StringUtils from '../utils';

/**
 * GiftTypeTag props
 */
interface Props {
  gift: Gift;
}

/**
 * GiftTypeTag Component
 */
const GiftTypeTag: FunctionComponent<Props> = ({ gift }) => (
  <Tag>
    {StringUtils.capitalize(
      (gift.status || '').toLowerCase(),
    )}
  </Tag>
);

export default GiftTypeTag;
